import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { get, pageContext } from 'ctm-util-functions';
import { getFeatureFlag } from 'ctm-selectors/selectors/base';
import { IconTextToggle } from './icon_text_toggle';
import { IconToggle } from './icon_toggle';
import { Icon } from '../icon/icon';
import styles from './compare_toggle.css';

class CompareToggle extends Component {

    /**
     * Logic to toggle the selection of the product using the props to decide on what to do.
     */
    handleClick = () => {
        const { isDisabled, isSelected, toggleProduct, toggleCompare, compareModeActive, selectedProductIds, minProducts } = this.props;

        if (!isDisabled || isSelected) {
            // If we're in compare mode and we deselect a product, and it reaches minProducts, disable compare mode.
            if (compareModeActive && selectedProductIds.size === minProducts) {
                toggleCompare(false);
            }
            // Invert the current selection
            toggleProduct(!isSelected);
        }
    };

    /**
     * The toggle icon has many states which is driven by props and schema,
     * this function contains the logic to determine what icon variant to use.
     * @returns {Node} Icon component with the correct variant.
     */
    generateIcon = () => {
        const { isDisabled, isSelected, visualProps } = this.props;

        let UIComponent = visualProps.UIComponent;

        if (isSelected) {
            UIComponent = `${UIComponent}_active`;
        } else if (isDisabled) {
            UIComponent = `${UIComponent}_disabled`;
        }
        const props = { ...visualProps, UIComponent };

        return <Icon {...props} className={styles.icon} />;
    };

    render = () => {
        const { displayMode, isSelected, stateProps } = this.props;
        const icon = this.generateIcon();
        const breakpoint = get(stateProps, 'breakpoint', pageContext.getProps().pageState.breakpoint);
        const hasSavedResults = getHasSavedResults() || getFeatureFlag('prefillHasSavedResults');
        const vertical = pageContext.getVertical();

        if (hasSavedResults) {
            return <></>;
        }

        if (['sm', 'md', 'lg', 'xl'].includes(breakpoint) && displayMode === 'row') {
            return <IconTextToggle icon={icon} handleClick={this.handleClick} isSelected={isSelected} />;
        }
        return <IconToggle icon={icon} handleClick={this.handleClick} isSelected={isSelected} showLabel={breakpoint !== 'xs'} />;
    };

}

CompareToggle.propTypes = {
    displayMode: PropTypes.string,
    selectedProductIds: PropTypes.instanceOf(Immutable.List),
    compareModeActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    toggleProduct: PropTypes.func.isRequired,
    toggleCompare: PropTypes.func.isRequired,
    minProducts: PropTypes.number.isRequired,
    visualProps: PropTypes.shape({
        size: PropTypes.string,
        color: PropTypes.string,
        UIComponent: PropTypes.string
    }),
    stateProps: PropTypes.shape({
        breakpoint: PropTypes.string
    }),
};

CompareToggle.defaultProps = {
    displayMode: 'row'
};

export { CompareToggle };
